module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chaptertitle1"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword")]), _vm._v(" by Paula Newby-Fraser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("|")]), _vm._v(" "), _c('b', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_c('i', [_vm._v("Evolution to a Running Revolution")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("1 |")]), _vm._v(" What Is Natural Running?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("2 |")]), _vm._v(" Evolution of a Sport and a Shoe")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("3 |")]), _vm._v(" Into the Lab")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Examining Your Running Form")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("4 |")]), _vm._v(" The Science of Motion")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Three Gaits")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("5 |")]), _vm._v(" Foot Biomechanics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Close Examination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("6 |")]), _vm._v(" The Physics of Running")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Whole-Body Kinematics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("7 |")]), _vm._v(" A New Way to Look at Common Running Injuries")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("8 |")]), _vm._v(" Natural Running, Unnatural World")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("9 |")]), _vm._v(" Dynamic Strength and Form Drills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3a"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "color_s1"
  }, [_vm._v("10 |")]), _vm._v(" Natural Running")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3b"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Eight-Week Transition Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/resources",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/about_the_author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ac24c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 75
// module chunks = 0